// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__hKCVP","left":"StickyBox_left__2-U2H","right":"StickyBox_right__24ywa"};